<template>
  <div class="row">
    <div class="col-md-12 pt-0 pb-0">
      <div class="row" v-for="(item, key) in []" :key="key">
        <div
          class="col-md-12 pt-0 pb-0 c-warning text-right"
          v-if="item.resident_account"
        >
          LANÇAMENTO FATURADO
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <div class="row">
            <div class="col-md-6 input-form-required">
              <input
                disabled
                placeholder="Descrição"
                type="text"
                v-model="item.description"
                class="form-control form-control-sm"
              />
            </div>
            <div class="col-md-2 input-form-required">
              <select
                disabled
                v-model="item.spent_or_gain"
                class="form-control form-control-sm"
              >
                <option value="DEBITO">DÉBITO</option>
                <option value="CREDITO">CRÉDITO</option>
              </select>
            </div>
            <div class="col-md-4 input-form-required">
              <input
                disabled
                placeholder="Valor"
                type="text"
                v-model="item.value"
                :class="[
                  'form-control form-control-sm',
                  item.spent_or_gain == 'DEBITO' && 'c-danger',
                  item.spent_or_gain == 'CREDITO' && 'c-success',
                ]"
              />
            </div>
            <div class="col-md-3 vue-treeselect-required">
              <treeselect
                disabled
                :options="finance_configuration_category"
                placeholder="SELECIONE..."
                v-model="item.finance_configuration_category_id"
                noChildrenText="NÃO POSSUI CATEGORIA(S) FILHA(S)"
              />
            </div>
            <div class="col-md-3">
              <select
                disabled
                v-model="item.finance_configuration_profit_cost_center_id"
                class="form-control form-control-sm"
              >
                <option :value="null">Centro de custo/lucro...</option>
                <option
                  v-for="profit_cost_center in finance_configuration_profit_cost_center"
                  :key="profit_cost_center.id"
                  :value="profit_cost_center.id"
                >
                  {{ profit_cost_center.description }}
                </option>
              </select>
            </div>
            <div class="col-md-3" v-if="item.spent_or_gain == 'DEBITO'">
              <select
                disabled
                v-model="item.provider_id"
                class="form-control form-control-sm"
              >
                <option :value="null">Fornecedor...</option>
                <option
                  v-for="provider in providers"
                  :key="provider.id"
                  :value="provider.id"
                >
                  {{ provider.company_name }}
                </option>
              </select>
            </div>
            <div class="col-md-3" v-if="item.spent_or_gain == 'CREDITO'">
              <select
                disabled
                v-model="item.finance_client_id"
                class="form-control form-control-sm"
              >
                <option :value="null">Cliente...</option>
                <option
                  v-for="client in finance_client"
                  :key="client.id"
                  :value="client.id"
                >
                  {{ client.name }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <select
                disabled
                v-model="item.finance_configuration_payment_methods_id"
                class="form-control form-control-sm"
              >
                <option :value="null">Forma de pagamento...</option>
                <option
                  v-for="payment_method in finance_configuration_payment_methods"
                  :key="payment_method.id"
                  :value="payment_method.id"
                >
                  {{ payment_method.description }}
                </option>
              </select>
            </div>
            <div class="col-md-6">
              <vs-select
                disabled
                class="
                  col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12
                  pt-0
                  pb-0
                  pl-0
                  pr-0
                "
                placeholder="Tags..."
                multiple
                autocomplete
                v-model="item.finance_configuration_tag_ids"
              >
                <vs-select-item
                  v-for="tag in finance_configuration_tag"
                  :key="tag.id"
                  :text="tag.description"
                  :value="tag.id"
                />
              </vs-select>
            </div>
            <div class="col-md-3">
              <select
                disabled
                v-model="item.cost_type"
                class="form-control form-control-sm"
              >
                <option :value="null">Tipo de custo...</option>
                <option
                  v-for="type in cost_types"
                  :key="type.value"
                  :value="type.value"
                >
                  {{ type.description }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <select
                disabled
                v-model="item.cost_appropriation"
                class="form-control form-control-sm"
              >
                <option :value="null">Apropriação de custo...</option>
                <option
                  v-for="appropriation in cost_appropriations"
                  :key="appropriation.value"
                  :value="appropriation.value"
                >
                  {{ appropriation.description }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-12 pt-0 pb-0"><hr /></div>
      </div>
    </div>
    <div
      v-if="
        data.is_resident && data.finance_client_resident_id && data.is_paid != 1
      "
      class="col-md-12 mb-2 pt-2 pb-5"
    >
      <Closure
        :id="data.id"
        :finance_launch_bills_to_pay_id="data.finance_launch_bills_to_pay_id"
        :finance_client_id="data.finance_client_id"
        :resident_id="data.finance_client_resident_id"
        :finance_client="finance_client"
        :finance_configuration_payment_methods="
          finance_configuration_payment_methods
        "
        :finance_configuration_category="finance_configuration_category"
        :finance_configuration_profit_cost_center="
          finance_configuration_profit_cost_center
        "
        :finance_configuration_tag="finance_configuration_tag"
        :cost_types="cost_types"
        :cost_appropriations="cost_appropriations"
        @postPendingBilling="postPendingBilling"
      />
    </div>
    <div class="col-md-12 pb-0">
      <v-btn class="btn-cancel mr-2" @click="handleCancel"
        ><i class="fas fa-times mr-2"></i>CANCELAR
      </v-btn>
    </div>
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";

import Closure from "./Closure";

import {
  formatValueOnKeyUp,
  formatValueNegativeOnKeyUp,
} from "../../../../../lib/format";

import moment from "moment";

export default {
  name: "Edit",

  components: {
    Treeselect,
    Closure,
  },

  props: {
    data: Object,
    providers: Array,
    finance_client: Array,
    finance_configuration_account: Array,
    finance_configuration_document_types: Array,
    finance_configuration_payment_methods: Array,
    finance_configuration_category: Array,
    finance_configuration_profit_cost_center: Array,
    finance_configuration_tag: Array,
    cost_types: Array,
    cost_appropriations: Array,
  },

  data() {
    return {
      finance_configuration_account_id: "",
      due_date: "",
      finance_configuration_document_types_id: "",
      how_many_times: "",
      document_number: "",
      competence: "",
      note: "",
      paid_in_date: "",
      periodicity: "",
      repeat: "NAO_SE_REPETE",
      is_paid: false,

      items: [],
      itemsWithId: [],

      loading: false,
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatValueOnKeyUp,
    formatValueNegativeOnKeyUp,

    postPendingBilling() {
      this.$emit("postPendingBilling");
    },

    retrieve() {
      let { data } = this;

      this.finance_configuration_account_id =
        data.finance_configuration_account_id;
      this.due_date = data.due_date
        ? moment(data.due_date).format("YYYY-MM-DD")
        : "";
      this.finance_configuration_document_types_id =
        data.finance_configuration_document_types_id;
      this.how_many_times = data.how_many_times;
      this.document_number = data.document_number;
      this.paid_in_date = data.paid_in_date
        ? moment(data.paid_in_date).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD");
      this.competence = data.competence
        ? moment(data.competence).format("YYYY-MM-DD")
        : "";
      this.periodicity = data.periodicity;
      this.note = data.note ? data.note : "";
      this.is_paid = data.is_paid == 1 ? true : false;

      this.repeat = data.is_repeat ? data.is_repeat : "";

      let itemsWithId = [];
      for (let item of data.items) {
        if (item.spent_or_gain == "DEBITO") {
          item.value = formatValueNegativeOnKeyUp(item.value);
        } else {
          item.value = formatValueOnKeyUp(item.value);
        }
        itemsWithId.push(item.id);
        this.items.push({
          id: item.id,
          description: item.description,
          value: item.value,
          finance_configuration_category_id:
            item.finance_configuration_category_id,
          finance_configuration_profit_cost_center_id:
            item.finance_configuration_profit_cost_center_id,
          provider_id: item.provider_id,
          finance_client_id: item.finance_client_id,
          finance_configuration_payment_methods_id:
            item.finance_configuration_payment_methods_id,
          finance_configuration_tag_ids: item.finance_configuration_tag_ids,
          cost_type: item.cost_type,
          cost_appropriation: item.cost_appropriation,
          spent_or_gain: item.spent_or_gain,
          resident_account: item.resident_account,
          resident_has_accommodation_item_id:
            item.resident_has_accommodation_item_id,
        });
      }
      this.itemsWithId = itemsWithId;
    },

    handleCancel() {
      this.$emit("cancel");
    },
  },
};
</script>